import React from "react";
import { Flame } from "lucide-react";

const dayKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
const WD = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

function computeStreak(sessions) {
  const days = new Set(sessions.filter((s) => s.created_date).map((s) => dayKey(new Date(s.created_date))));
  const d = new Date();
  if (!days.has(dayKey(d))) d.setDate(d.getDate() - 1);
  let current = 0;
  while (days.has(dayKey(d))) { current++; d.setDate(d.getDate() - 1); }
  const sorted = [...new Set(sessions.filter((s) => s.created_date).map((s) => new Date(s.created_date).setHours(0, 0, 0, 0)))].sort((a, b) => a - b);
  let best = 0, run = 0, prev = null;
  sorted.forEach((t) => { run = prev !== null && Math.round((t - prev) / 86400000) === 1 ? run + 1 : 1; best = Math.max(best, run); prev = t; });
  return { current, best, days };
}

export function StudyStreak({ sessions }) {
  const { current, best, days } = computeStreak(sessions);
  const learnedToday = days.has(dayKey(new Date()));
  const last14 = Array.from({ length: 14 }, (_, i) => { const d = new Date(); d.setDate(d.getDate() - (13 - i)); return d; });
  const msg = current === 0 ? "Starte heute eine Lerneinheit und beginne deine Serie!"
    : learnedToday ? "Stark! Du hast heute schon gelernt – bleib dran." : "Lerne heute, damit deine Serie nicht abreisst!";
  return (
    <section className="modern-streak" data-testid="stats-streak" aria-label="Lernserie">
      <div className={`modern-streak-flame ${current ? "" : "is-off"}`}><Flame className="h-8 w-8" /></div>
      <div className="modern-streak-main">
        <h2 data-testid="stats-streak-current">{current} {current === 1 ? "Tag" : "Tage"} Lernserie <span className="modern-streak-best" data-testid="stats-streak-best">Rekord: {best}</span></h2>
        <p>{msg}</p>
        <div className="modern-streak-days" data-testid="stats-streak-days">
          {last14.map((d) => {
            const k = dayKey(d); const today = k === dayKey(new Date());
            return (
              <div key={k} className="modern-streak-day" title={d.toLocaleDateString("de-CH")}>
                <span className={`modern-streak-dot ${days.has(k) ? "is-on" : ""} ${today ? "is-today" : ""}`} />
                {WD[d.getDay()]}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
